/** Registre des types de véhicules. Chaque type = la géométrie du CORPS (taille + arrondi)
 *  ET sa conduite (VehicleParams). Source de vérité unique, partagée physique + rendu. Le
 *  lacet étant divisé par la longueur (cf. TURN_REF_LENGTH), un corps plus long vire déjà plus
 *  large « tout seul » ; les params ci-dessous ajoutent le reste du caractère (vitesse, délai…). */
import { DEFAULT_VEHICLE, type VehicleParams } from './vehicle';

export interface VehicleDef {
  /** Longueur du corps (px, sens du cap). */
  w: number;
  /** Largeur latérale (px). */
  h: number;
  /** Rayon d'arrondi des coins (px). */
  chamfer: number;
  /** Conduite (feeling) propre au type. */
  params: VehicleParams;
}

export const VEHICLES: Record<string, VehicleDef> = {
  car: { w: 28, h: 18, chamfer: 4, params: DEFAULT_VEHICLE },
  // Bus : long (vire large via la longueur), plus lent, et des roues qui tournent lentement
  // (steerResponse bas = gros délai de braquage), plus dur à faire décrocher.
  bus: {
    w: 62,
    h: 22,
    chamfer: 5,
    params: {
      ...DEFAULT_VEHICLE,
      engineForce: 820,
      brakeForce: 1500,
      reverseForce: 500,
      maxSpeed: 300,
      reverseMaxSpeed: 110,
      steerResponse: 3.0,
      gripAccel: 1500, // plus collé que la voiture : un bus ne décroche pas en braquant
      handbrakeGripAccel: 160, // ... mais le frein à main le fait bien déraper (skidmarks)
    },
  },
};

/** Type par défaut quand une voiture n'en précise pas. */
export const DEFAULT_VEHICLE_TYPE = 'car';

/** Résout un nom de type en définition complète (replie sur le défaut si inconnu/absent). */
export function getVehicle(type?: string | null): VehicleDef {
  return VEHICLES[type ?? DEFAULT_VEHICLE_TYPE] ?? VEHICLES[DEFAULT_VEHICLE_TYPE];
}
